import { api } from '../libs/api'
import { getRequestConfig } from '../utils/auth'

export interface Settings {
  _id: string
  defaultTrialPeriod: number
  defaultBasePlanCost: number
  defaultAgencySeatCost: number
  defaultStandaloneSubscriptionCost: number
  createdAt: string
  updatedAt: string
}

export interface UpdateSettingsData {
  defaultTrialPeriod: number
  defaultBasePlanCost: number
  defaultAgencySeatCost: number
  defaultStandaloneSubscriptionCost: number
}

export interface SettingsResponse {
  success: boolean
  data: Settings
  message?: string
  error?: string
}

export interface UpdateSettingsResponse {
  success: boolean
  data: Settings
  message?: string
  error?: string
}

class SettingsService {
  private readonly baseUrl = '/settings'

  async getSettings(): Promise<Settings> {
    try {
      const response = await api.get(this.baseUrl, getRequestConfig()) as SettingsResponse

      if (!response.success) {
        throw new Error(response.error || 'Failed to fetch settings')
      }

      return response.data
    } catch (error) {
      console.error('Error fetching settings:', error)
      throw error
    }
  }

  async updateSettings(settingsData: UpdateSettingsData): Promise<Settings> {
    try {
      const response = await api.put(this.baseUrl, settingsData, getRequestConfig()) as UpdateSettingsResponse

      if (!response.success) {
        throw new Error(response.error || 'Failed to update settings')
      }

      return response.data
    } catch (error) {
      console.error('Error updating settings:', error)
      throw error
    }
  }
}

// Create and export the service instance
export const settingsService = new SettingsService()
export default settingsService 